import { render, staticRenderFns } from "./MobileJobList.vue?vue&type=template&id=2dfbffba&scoped=true&"
import script from "./MobileJobList.vue?vue&type=script&lang=js&"
export * from "./MobileJobList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MobileJobList.vue?vue&type=style&index=0&id=2dfbffba&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2dfbffba",
  null
  ,true
)

export default component.exports